<template>
  <div>
    <!-- <data-tracker>
      <span class="text-body-1">Password:</span>
      {{ this.$store.getters["Profile/accountInfo"].password.value }}
    </data-tracker> -->

    <!----- Headline ------>
    <headline-bar :extend-x="6" class="mb-6">
      <template v-slot:prepend-btn>
        <v-btn icon class="d-md-none">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>

      Profile

      <!-- <template v-slot:btn-icon-1>
        <v-btn icon class="ml-2">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </template> -->
    </headline-bar>

    <!----- Main Components ------>
    <v-row>
      <v-col v-if="!isProfileComplete" cols="12">
        <alert-content></alert-content>
      </v-col>

      <v-col cols="12" md="6" class="d-flex flex-column">
        <account-info class="flex-grow-1"></account-info>
      </v-col>

      <v-col cols="12" md="6" class="d-flex flex-column">
        <personal-info class="flex-grow-1"></personal-info>
      </v-col>

      <v-col cols="12" class="d-flex flex-column">
        <location-info class="flex-grow-1"></location-info>
      </v-col>

      <v-col cols="12" class="d-flex flex-column">
        <contact-info class="flex-grow-1"></contact-info>
      </v-col>
    </v-row>

    <v-spacer class="my-8"></v-spacer>
  </div>
</template>

<script>
import alertContent from "../components/profile/alertContent";
import accountInfo from "../components/profile/accountInfo";
import personalInfo from "../components/profile/personalInfo";
import locationInfo from "../components/profile/locationInfo";
import contactInfo from "../components/profile/contactInfo";
export default {
  data() {
    return {
      pageName: "Profile!",
      snackbar: true,
    };
  },
  components: {
    "alert-content": alertContent,
    "account-info": accountInfo,
    "personal-info": personalInfo,
    "location-info": locationInfo,
    "contact-info": contactInfo,
  },
};
</script>

<style lang="sass" scoped>
</style>
